import { useDispatch } from 'react-redux'
import { SaasTierType } from 'src/models/organizations.models'
import { connectedPush } from 'src/navigation/Lnk'
import { upgradeSubscriptionUrl } from 'src/navigation/urls'
import { usePostEnterpriseRequest } from 'src/queries/organizations/saas.queries'

export const useSaasUpgradeAction = (
  /**
   * must be provided if upgradeTier is ENTERPRISE, otherwise no action will happen
   */
  orgId?: string,
): ((requiredTier: SaasTierType, intention: string) => void) => {
  const dispatch = useDispatch()
  const { mutate: postEnterpriseRequest } = usePostEnterpriseRequest()

  return (requiredTier: SaasTierType, intention: string) => {
    switch (requiredTier) {
      case 'STARTER':
        return
      case 'PRO':
        dispatch(connectedPush(upgradeSubscriptionUrl()))
        return
      case 'ENTERPRISE':
        if (orgId === undefined) {
          return
        }
        postEnterpriseRequest({
          orgId,
          body: {
            intention,
          },
        })
        return
    }
  }
}
